import type { SRT_Header, SRT_RowData, SRT_TableInstance } from '../../types'

import React from 'react'

import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

import { parseFromValuesOrFunc } from '../../utils/utils'

export function SRT_TableHeadLabel<T extends SRT_RowData>({
	header,
	table,
}: {
	header: SRT_Header<T>
	table: SRT_TableInstance<T>
}) {
	const { column } = header
	const {
		options: { enableHeaderTooltip },
	} = table
	const headerElement =
		parseFromValuesOrFunc(column.columnDef.Header, {
			column,
			header,
			table,
		}) ?? column.columnDef.header

	const showTooltip =
		enableHeaderTooltip &&
		(column.columnDef.enableHeaderTooltip !== false ||
			column.columnDef.enableDescriptionTooltip !== false)

	if (showTooltip) {
		return (
			<Tooltip>
				<TooltipTrigger asChild>
					<span
						className='truncate'
						data-testid={`mt-header-label-${column.id}`}
					>
						{headerElement}
					</span>
				</TooltipTrigger>
				<TooltipContent>
					<div className='max-w-56'>
						{column.columnDef.enableHeaderTooltip !== false && (
							<p className='text-xs font-medium'>
								{header.column.columnDef.header}
							</p>
						)}
						{column.columnDef.enableDescriptionTooltip !== false && (
							<p className='text-xs text-background/60'>
								{column.columnDef.description}
							</p>
						)}
					</div>
				</TooltipContent>
			</Tooltip>
		)
	}

	return <span className='truncate'>{headerElement}</span>
}
